/* global ADV */

import * as actions from './TopNavActions';
import { solveNavigation } from './TopNavHelpers';

const getNavigation = (client, isConsumerArea = true) => {
  const currentClient = client || ADV.util.getCurrentClient(ADV.data);

  return solveNavigation(
    JSON.parse(JSON.stringify(currentClient.ModulesToHide || [])),
    currentClient.ConsumerAccessWorkflow || -1,
    currentClient.Id,
    isConsumerArea,
  );
};

const initialState = {
  allow_full_screen: false,
  navigation: [],
};

const TopNavReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.INITIALIZE:
      return {
        ...state,
        allow_full_screen:
          action.isConsumerArea && ADV.info.isPresentationMode && !ADV.util.env('isiOS'),
        navigation: getNavigation(action.currentClient, action.isConsumerArea),
      };
    case actions.SET_WORKFLOW:
      return Object.assign({}, state, {
        workflow: action.workflow,
      });
    case actions.REFRESH_NAVIGATION:
      return Object.assign({}, state, {
        navigation: getNavigation(),
      });
    default:
      return state;
  }
};

export default TopNavReducer;
